import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";
import {
    type DomainAggregateConfiguration,
    domainAggregateConfigurationValidator,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/domainAggregateWorkspaceCapability/domain/DomainAggregateConfiguration";

export type DomainAggregateTemplate = {
    configuration: DomainAggregateConfiguration;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    domainAggregateName: string;
    id: Uuid;
    revisionId: Uuid;
    status: DomainAggregateTemplateStatus;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
};

export enum DomainAggregateTemplateStatus {
    active = "694c2abb-5fa5-4f7f-bfaf-703adaa7102c",
    archived = "4adeac57-6456-4a7b-af14-7923abfb6ba0",
}

export const domainAggregateTemplateValidator: zod.ZodType<DomainAggregateTemplate> = zod.strictObject({
    configuration: domainAggregateConfigurationValidator,
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    domainAggregateName: zod.string().min(1),
    id: uuidZodValidator,
    revisionId: uuidZodValidator,
    status: zod.enum(DomainAggregateTemplateStatus),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
});
